import Popover from "./Popover.vue";
import { pluginify } from "./../../util";
export default pluginify(Popover);
export { Popover };
